import Vue from 'vue'
import 'chartist/dist/chartist.min.css'
import VueHighcharts from 'vue-highcharts'

Vue.use(VueHighcharts) // https://www.npmjs.com/package/vue-highcharts
Vue.use(require('vue-chartist'))
